import * as $ from "jquery";

export function initializeCartCounts() {
    window.addEventListener('load', function () {
        UpdateCartCounts();
    })
}
// User navigation Cart Counts
export function UpdateCartCounts() {
    const NoItemsClass = "no-items";
    $.get("/api/cartcounts/byuser",
        function (data) {
            try {
                var counts = $.parseJSON(data);

                var cartCount = $('.nav-utility-list-item-cart-count');
                cartCount.html(counts.cartCount);


                if (counts.cartCount === "0") {
                    cartCount.addClass(NoItemsClass);
                }
                else {
                    cartCount.removeClass(NoItemsClass);
                }

                var compareCount = $('.nav-utility-list-item-compare-count');
                compareCount.html(counts.compareCount);
                if (counts.compareCount === "0") {
                    compareCount.addClass(NoItemsClass);

                }
                else {
                    compareCount.removeClass(NoItemsClass);
                }

            } catch (e) { }
        },
        "json");
};